export default "__VITE_ASSET__B5jn919q__"